import { Box, BoxProps } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { RefreshRequiredIcon } from 'components/uikit/icons';
import {
  countryCodeByMethod,
  DepositCredentials,
  DepositMethod,
  isMobcomMethod,
} from 'data/payments/models';

interface PaymentNoticeProps extends Omit<BoxProps, 'style'> {
  method: DepositMethod | null;
  credentials: DepositCredentials;
  style?: 'default' | 'riobet' | '1xbet';
  fromBank?: string | null;
}

export const PaymentNotice = ({
  method,
  credentials,
  fromBank,
  style = 'default',
  ...props
}: PaymentNoticeProps) => {
  const { t } = useTranslation('payments');
  const isBranded = style === 'riobet' || style === '1xbet';

  if (isMobcomMethod(method)) return null;

  if (method === 'INR') return null;

  const isPdfMethod = method === 'SBP_PDF' || method === 'CARD_PDF';

  const tgCountry = countryCodeByMethod[method ?? 'SBP'];
  const showBankNotice = !(
    (!tgCountry || tgCountry === 'RU') &&
    credentials.type !== 'SBP'
  );
  if (!showBankNotice && !isPdfMethod) return null;

  return (
    <Box
      borderRadius='12px'
      textAlign='start'
      display='flex'
      alignItems='flex-start'
      justifyContent='flex-start'
      gap='10px'
      p='12px'
      bgColor='payment.notice'
      borderWidth={isBranded ? '1px' : '0'}
      borderColor='payment.noticeBorder'
      color='payment.noticeText'
      fontSize='md'
      {...props}
    >
      <Box flexShrink={0} alignSelf='flex-start'>
        <RefreshRequiredIcon boxSize='18px' color='payment.noticeText' />
      </Box>
      <Box display='flex' flexDirection='column' gap='8px'>
        {showBankNotice && (
          <Box>
            {!tgCountry
              ? t('payment_notice_sbp', { bank: credentials.bank })
              : tgCountry === 'VN'
              ? t('payment_notice_tg_vn', {
                  bank: credentials.type === 'QR' ? fromBank : credentials.bank,
                })
              : t('payment_notice_tg', {
                  country: t(`payment_tg_country_${tgCountry.toLowerCase()}`),
                  bank: credentials.type === 'QR' ? fromBank : credentials.bank,
                })}
          </Box>
        )}
        {isPdfMethod && (
          <Box fontWeight='600'>{t('payment_notice_pdf_receipt')}</Box>
        )}
      </Box>
    </Box>
  );
};
